/* Copiare negli appunti, con la rete di sicurezza.
 *
 * `navigator.clipboard` non c'è sempre: manca fuori dai contesti sicuri e può
 * essere negato dai permessi. Dentro il guscio dell'app la pagina arriva in
 * https, quindi c'è; ma il ripiego serve lo stesso, perché un "copia" che non
 * copia e non lo dice è peggio di un comando assente.
 *
 * Il ripiego è il vecchio `execCommand('copy')` su una textarea fuori
 * schermo: deprecato, ma è l'unica strada quando l'API moderna non c'è.
 */
export async function copia(testo) {
  if (!testo) return false;
  try {
    await navigator.clipboard.writeText(testo);
    return true;
  } catch {
    // Si prova alla vecchia maniera prima di arrendersi.
  }
  try {
    const campo = document.createElement('textarea');
    campo.value = testo;
    campo.setAttribute('readonly', '');
    campo.style.cssText = 'position:fixed;top:-1000px;opacity:0';
    document.body.appendChild(campo);
    campo.select();
    const fatto = document.execCommand('copy');
    campo.remove();
    return fatto;
  } catch {
    return false;
  }
}
